export default __webpack_public_path__ + "static/media/english-to-polish-screenshot-05.4cd97263.png";